import React, { useState, useEffect } from 'react';
import { styled } from '@material-ui/core';
import { useDebounce } from '../../hooks/useDebounce';
import IconSearch from '../icons/iconSearch';

const DELAY_MILLISECONDS = 500;

interface NkSearchInputProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

export const NkSearchInput = ({
  onSearch,
  placeholder = 'search...',
}: NkSearchInputProps) => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [isCleared, setIsCleared] = useState<boolean>(true);

  const debounceValue = useDebounce({
    value: searchQuery,
    delay: DELAY_MILLISECONDS,
  });

  useEffect(() => {
    if (isCleared) {
      setIsCleared(false);
    } else {
      onSearch(debounceValue);
    }
  }, [debounceValue]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    if (event.target.value === '' && debounceValue === '') {
      setIsCleared(true);
    }
  };

  return (
    <SearchInputContainer>
      <StyledIconSearch color="black" />
      <SearchInputField
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleInputChange}
      />
    </SearchInputContainer>
  );
};

const SearchInputContainer = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '50px',
  backgroundColor: '#fff',
  padding: theme.spacing(),
}));

const StyledIconSearch = styled(IconSearch)(({ theme }) => ({
  margin: `0 ${theme.spacing()}px`,
}));

const SearchInputField = styled('input')({
  flex: 1,
  border: 'none',
  fontSize: '16px',
  '&:focus': {
    outline: 'none',
  },
});
